import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import { SingleSelect } from "react-select-material-ui";
import Moment from "react-moment";
import moment from "moment-timezone";
import { findIana } from "windows-iana";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Tip,
  Spinner,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  Clock,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
  callApiGetJsonwithEP,
} from "./GlobalSettings";
import Launchdemospinner from "./Launchdemospinner";
import InfoWarning from "./InfoWarning";
/* import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker } from "@material-ui/pickers"; */
import AvailableTimeSlots from "./AvailableTimeSlots";
import ScheduleDemoOverlayB from "./ScheduleDemoOverlayB";

class ScheduleDemoOverlayA extends Component {
  constructor(props) {
    super(props);

    this.state = {
      eventTypeData: undefined,
      TimeZoneData: undefined,
      timezoneValue: undefined,
      mainInstructor: auth.getUserEmail(),
      eventDeliveryLocationData: undefined,
      demoEvtTypeVal: "Select Event Type",
      demoEvtDelLocVal: " Select Delivery Location",
      // isEvtListDisabled: true,
      EvtTypeSelected: undefined,
      isAdministrator: false,
      EvtDelLocSelected: undefined,
      timezoneSpecificTime: null,
      // isDelLocDisabled: true,
      DemoData: this.props.demo,
      IsMultiDaySelected: false,
      durationSelectedVal: "Select Event Duration",
      EvtDuration: undefined,
      startDateValue: undefined, //new Date(),
      endDateValue: undefined, // new Date(),
      showAvailableEventTimes: false,
      newEventRequestVM: {
        Event_ID: 0,
        Event_Title: this.props.demo.Content_Title, //default title to content title
        Event_Description: this.props.demo.Content_Title, //default title to content title
        Event_Status: {
          EventStatus_ID: 1,
        },
        PhysicalContents: null,
        EventTimeZone: null,
        Event_TMECR_FriendlyPwd: null,
        HoustonSeatCountSelected: this.props.Is_TMECR ? new Array() : null,
        SingaporeSeatCountSelected: this.props.Is_TMECR ? new Array() : null,
        BristolSeatCountSelected: this.props.Is_TMECR ? new Array() : null,
        MainPresenter: null,
        PhysicalEquipment: null,
        Event_Type: {
          EventType_Enabled: true,
          EventType_ID: null,
          EventType_Name: null,
        },
        Event_NoOppIDReason: null,
        Event_DeliveryLocation: {
          EventDeliveryLocation_Enabled: true,
          EventDeliveryLocation_ID: null,
          EventDeliveryLocation_Name: null,
        },
        Event_Requester: null,
        Event_OpportunityID: null,
        Event_CustomerName: null,
        Event_Presenter: { EmailAddress: null },
        Event_Duration: { Duration_ID: null, Duration_Name: null },
        Is_Extension: false,
      },
      eventAvailableEventTimes: undefined,
      bshowAvailTimeLoader: false,
      isEvtTypeDisabled: true,
      isDelLocDisabled: true,
      sliderValue: undefined,
      showAvailableSlotLoader: false,
      selectedStartTime: undefined,
      selectedStartActualDateVal: undefined,
      showNextOverlayB: false,
    };

    this.loadEventTypes = this.loadEventTypes.bind(this);
    this.loadEventDeliveryLocations =
      this.loadEventDeliveryLocations.bind(this);
    this.loadTimeZoneData = this.loadTimeZoneData.bind(this);
    this.handleTimeZone = this.handleTimeZone.bind(this);
    this.handleMainInstructor = this.handleMainInstructor.bind(this);
    this.handleDemoEventTypeChange = this.handleDemoEventTypeChange.bind(this);
    this.handleDemoEventDelLocChange =
      this.handleDemoEventDelLocChange.bind(this);
    this.handleDurationChange = this.handleDurationChange.bind(this);
    this._isStartTimeBeforeEndTime = this._isStartTimeBeforeEndTime.bind(this);
    this._handleStartDateChange = this._handleStartDateChange.bind(this);
    this._handleEndDateChange = this._handleEndDateChange.bind(this);
    this._invalidStartDate = this._invalidStartDate.bind(this);
    this._invalidEndDate = this._invalidEndDate.bind(this);
    this.loadAvailableEventTimes = this.loadAvailableEventTimes.bind(this);
    this.loadMultiDayAvailableEventTimes =
      this.loadMultiDayAvailableEventTimes.bind(this);
    this._handleAvailableTimeSelected =
      this._handleAvailableTimeSelected.bind(this);
    this._hideAvailableTimeWindow = this._hideAvailableTimeWindow.bind(this);
    this._showNextOverlayB = this._showNextOverlayB.bind(this);
    this._hideNextOverlayB = this._hideNextOverlayB.bind(this);
    this._hideOnlyOverlayB = this._hideOnlyOverlayB.bind(this);
    this.checkIsAdmin = this.checkIsAdmin.bind(this);
  }

  componentDidMount() {
    auth.verifyToken(true);
    this.checkIsAdmin();
    this.loadEventTypes();
    this.loadEventDeliveryLocations();
    if (this.props.Is_TMECR) {
      this.loadTimeZoneData();
    }
  }

  _showNextOverlayB() {
    this.setState({ showNextOverlayB: true });
    // this.props.hide();
  }

  checkIsAdmin() {
    var UsrDet = auth.getUserInfo();
    var UsrRls = UsrDet.UserAppRoles;
    //var usrPart = null;

    console.log("UserRoles are ", UsrRls);
    if (Array.isArray(UsrRls) && UsrRls.length > 0) {
      // var usrEmp = UsrRoles.find((ur) => ur.AppRoleName == "HPE Employee");
      var usrPart = UsrRls.find((ur) => ur.AppRoleName == "Administrator");
      //var usrCust = UsrRoles.find((ur) => ur.AppRoleName == "HPE Customer");

      if (usrPart === undefined) {
        //console.log("This is Employee", usrEmp);
        console.log("This is Not Admin guy");
      } else {
        this.setState({ isAdministrator: true });
      }
      //console.log("This is Customer", usrCust);
    }
  }

  loadTimeZoneData() {
    var endpoint = "/Metadata/GetTimezones";
    let token = auth.getToken();
    console.log(auth.getToken());
    callApiGetJson(endpoint, token).then((data) => {
      console.log("TimeZone data from API for Evt:", data);
      this.setState({
        TimeZoneData: data,
      });
    });
  }

  _hideOnlyOverlayB() {
    this.setState({ showNextOverlayB: false });
  }

  handleTimeZone(value) {
    var EVObject = this.state.newEventRequestVM;
    if (this.state.TimeZoneData) {
      this.state.TimeZoneData.map((tz) => {
        if (tz.Timezone_Name === value) {
          this.setState({ timezoneValue: tz.Timezone_ID });
          EVObject.EventTimeZone = tz.Timezone_ID;
        }
      });
    }
    this.setState({
      newEventRequestVM: EVObject,
      selectedStartDate: undefined,
      selectedStartActualDateVal: undefined,
      selectedStartTime: undefined,
    });
  }

  _hideNextOverlayB() {
    this.setState({ showNextOverlayB: false });
    this.props.hide();
  }

  handleMainInstructor(value) {
    console.log("Main Instructor Name with value ", value);
    var EVObject = this.state.newEventRequestVM;
    EVObject.MainPresenter = value;
    this.setState({ mainInstructor: value, newEventRequestVM: EVObject });
  }

  _hideAvailableTimeWindow() {
    this.setState({
      showAvailableEventTimes: false,
      eventAvailableEventTimes: undefined,
    });
  }

  _handleAvailableTimeSelected(selectedStartDate) {
    //Duration format is in dd.hh:mm
    console.log(
      "Callback props selected start date time passed param ",
      selectedStartDate
    );
    console.log(
      "Callback props selected start date time ",
      selectedStartDate.toString()
    );

    console.log(
      "Callback props selected start date time ",

      selectedStartDate.getMonth() +
        1 +
        "/" +
        selectedStartDate.getDate() +
        "/" +
        selectedStartDate.getFullYear()
    );

    var tzone =
      this.state.timezoneValue && this.props.Is_TMECR
        ? findIana(this.state.timezoneValue)[0]
        : moment.tz.guess();
    console.log(
      "Callback Props to selected only time part with time zone  converted date time ",
      moment(selectedStartDate.toISOString()).tz(tzone).format("h.mm:ss a")
    );

    console.log(
      "Event Duration already set was ",
      this.state.newEventRequestVM.Event_Duration
    );

    var splitEventDuration =
      this.state.newEventRequestVM.Event_Duration &&
      this.state.newEventRequestVM.Event_Duration.Duration_ID
        ? this.state.newEventRequestVM.Event_Duration.Duration_ID.split(".")
        : [0, "0:0"];
    //var calculatedEndDate = new Date(selectedStartDate.getTime());     //console.log(calculatedEndDate.toString());
    var durationMilliseconds =
      splitEventDuration[0] * 24 * 60 * 60 * 1000 +
      splitEventDuration[1].split(":")[0] * 60 * 60 * 1000 +
      splitEventDuration[1].split(":")[1] * 60 * 1000;
    var calculatedEndDate = new Date(
      selectedStartDate.getTime() + durationMilliseconds
    );
    console.log("CalculatedEndDate", calculatedEndDate.toString());
    //calculatedEndDate.setDate(selectedStartDate.getDate() + splitEventDuration[0]);
    //calculatedEndDate.setHours(selectedStartDate.getHours() + splitEventDuration[1].split(':')[0]);
    var startDateString =
      selectedStartDate.getFullYear() +
      "-" +
      (selectedStartDate.getMonth() + 1) +
      "-" +
      selectedStartDate.getDate() +
      "T" +
      selectedStartDate.getHours() +
      ":" +
      selectedStartDate.getMinutes() +
      ":" +
      selectedStartDate.getSeconds();
    var endDateString =
      calculatedEndDate.getFullYear() +
      "-" +
      (calculatedEndDate.getMonth() + 1) +
      "-" +
      calculatedEndDate.getDate() +
      "T" +
      calculatedEndDate.getHours() +
      ":" +
      calculatedEndDate.getMinutes() +
      ":" +
      calculatedEndDate.getSeconds();

    console.log(
      selectedStartDate.toString() +
        " -->" +
        startDateString +
        " --> " +
        selectedStartDate.toISOString()
    );
    console.log(this.state.newEventRequestVM.Event_Duration);
    console.log(
      calculatedEndDate.toString() +
        " -->" +
        endDateString +
        " --> " +
        calculatedEndDate.toISOString()
    );
    var EVObject = this.state.newEventRequestVM;
    //EVObject.Event_StartDate = startDateString;
    //EVObject.Event_EndDate = endDateString;
    //temporarily using the ISO string which converts it to UTC
    EVObject.Event_StartDate = selectedStartDate.toISOString();
    EVObject.Event_EndDate = calculatedEndDate.toISOString();
    this.setState({
      newEventRequestVM: EVObject,
      showAvailableEventTimes: false,
      eventAvailableEventTimes: undefined,
      startDateValue: undefined,
      timezoneSpecificTime: moment(selectedStartDate.toISOString())
        .tz(tzone)
        .format("h.mm:ss A"),
      //new Date(selectedStartDate).toISOString(),
      /* selectedStartDate.getMonth() +
        1 +
        "/" +
        selectedStartDate.getDate() +
        "/" +
        selectedStartDate.getFullYear(), */
      selectedStartTime: selectedStartDate.toTimeString(),
      selectedStartActualDateVal: new Date(
        selectedStartDate.getMonth() +
          1 +
          "/" +
          selectedStartDate.getDate() +
          "/" +
          selectedStartDate.getFullYear()
      ),
    });
  }

  handleDemoEventTypeChange(value) {
    console.log("**EvtType Select List Clicked with selection below");
    console.log(value);
    console.log("**All List of Event Types below");
    console.log(this.state.eventTypeData);
    var EVObject = this.state.newEventRequestVM;

    this.state.eventTypeData.map((evtTyp) => {
      if (evtTyp.EventType_Name == value) {
        EVObject.Event_Type = evtTyp; //JSON.parse(evtTyp);
        this.setState({
          EvtTypeSelected: evtTyp,
          demoEvtTypeVal: value,
          newEventRequestVM: EVObject,
        });
      }
    });
  }

  loadAvailableEventTimes(date, duration, phyID) {
    this.setState({ showAvailableSlotLoader: true });
    console.log(date);
    var endpoint = "/Events/GetAvailEventTimesByPhyContent";
    var postData =
      this.state.timezoneValue && this.props.Is_TMECR
        ? {
            Day: date,
            Duration: duration,
            PhysicalContentID: phyID,
            evtTimezone: this.state.timezoneValue,
          }
        : {
            Day: date,
            Duration: duration,
            PhysicalContentID: phyID,
            evtTimezone: null,
          };
    let token = auth.getToken();

    callApiPostJson(endpoint, postData, token).then((data) => {
      console.log("EventAvailableEventTimes data:" + data);
      if (data !== undefined) var reqestedDay = new Date(data.RequestedDay.Day);
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var sliderValue = 0.33;
      if (reqestedDay.toDateString() === today.toDateString()) {
        sliderValue = parseInt(new Date().getHours() / 6, 10) * 0.33;
      }

      this.setState({
        eventAvailableEventTimes: data,
        showAvailableEventTimes: true,
        showAvailableSlotLoader: false,
        // currentTab:"present",
        sliderValue: sliderValue,
      });
    });

    //this just refreshes the user token if necessary
    // auth.verifyToken(true);
  }

  _handleEndDateChange(event) {
    console.log("Handle End Date Fired");
    var value = new Date(event.value);
    console.log("Event End Date selected is ", value);

    console.log("Start Date selected is ", this.state.startDateValue);
    console.log("Duration Selected is ", this.state.Event_Duration);

    console.log("On End Date Change Below are imp info");
    console.log("IsMultidays Already Selected", this.state.IsMultiDaySelected);
    console.log(
      "IsMultidays  Selected then Duration Value",
      this.state.EvtDuration
    );
    console.log(
      "IsMultidays  Selected then Duration Value",
      this.state.Event_Duration
    );
    console.log("End TDate Selected as ", value);
    console.log(
      "Is Start Datetime earlier Than End Value ",
      this._isStartTimeBeforeEndTime(this.state.startDateValue, value)
    );

    if (this.state.IsMultiDaySelected) {
      //means it's a multiday event
      if (
        this.state.EvtDuration &&
        this.state.startDateValue &&
        this._isStartTimeBeforeEndTime(this.state.startDateValue, value)
      ) {
        //if all data filled out...do this
        var startDateFormatted =
          this.state.startDateValue.getFullYear() +
          "-" +
          (this.state.startDateValue.getMonth() + 1) +
          "-" +
          this.state.startDateValue.getDate();
        var endDateFormatted =
          value.getFullYear() +
          "-" +
          (value.getMonth() + 1) +
          "-" +
          value.getDate();
        console.log(startDateFormatted);
        console.log(endDateFormatted);
        this.loadMultiDayAvailableEventTimes(
          startDateFormatted,
          endDateFormatted,
          this.props.demo.Content_ID
        );
        this.setState({ showAvailableEventTimes: true });
      }

      // this.setState({ showEndTimeField: true }); //show end date if multidayevent selected
    } else if (this.state.EvtDuration && !this.state.IsMultiDaySelected) {
      var dateFormatted =
        value.getFullYear() +
        "-" +
        (value.getMonth() + 1) +
        "-" +
        value.getDate();
      this.loadAvailableEventTimes(
        dateFormatted,
        this.state.EvtDuration,
        this.props.demo.Content_ID
      );
      this.setState({ showAvailableEventTimes: true });
    }

    if (
      this.state.startDateValue &&
      this._isStartTimeBeforeEndTime(this.state.startDateValue, value)
    )
      this.setState({ endDateValue: value, selectedStartTime: undefined });
    //reset starttime if it's after endtime
    else
      this.setState({
        endDateValue: value,
        starTimeValue: undefined,
        selectedStartTime: undefined,
      });
  }

  loadMultiDayAvailableEventTimes(startdate, enddate, phyID) {
    //convert into duration to reuse existing endpoint
    startdate = startdate.split("-").join("/");
    enddate = enddate.split("-").join("/");
    var diff = Date.parse(enddate) - Date.parse(startdate) + 86400000; //86400000 is 24 hours in MS - adding to make it add to end of endDate and not beginning
    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    var durationInDays = days + ".00:00:00";
    console.log("Correct Timespan: ", durationInDays);

    var eventTmpObj = this.state.newEventRequestVM;
    eventTmpObj.Event_Duration.Duration_ID = durationInDays;
    eventTmpObj.Event_Duration.Duration_Name = "Multiday Event";
    this.setState({
      newEventRequestVM: eventTmpObj,
    });
    this.loadAvailableEventTimes(startdate, durationInDays, phyID);
  }

  _handleStartDateChange(event) {
    // console.log("Handle Start Date Change Fired with value ", value);
    console.log(
      "Handle Start Date Change Fired with event value ",
      event.value
    );

    var value = new Date(event.value);
    console.log(
      "Handle Start Date Change Fired with event value formatted is ",
      value
    );
    if (this.state.IsMultiDaySelected) {
      //means it's a multiday event
      if (
        this.state.EvtDuration &&
        this.state.endTimeValue &&
        this._isStartTimeBeforeEndTime(value, this.state.endTimeValue)
      ) {
        //if all data filled out...do this
        console.log(
          "diff in MS:",
          this.state.endTimeValue - this.state.startDateValue
        );
        var startDateFormatted =
          value.getFullYear() +
          "-" +
          (value.getMonth() + 1) +
          "-" +
          value.getDate();
        console.log(startDateFormatted);
        var endDateFormatted =
          this.state.endTimeValue.getFullYear() +
          "-" +
          (this.state.endTimeValue.getMonth() + 1) +
          "-" +
          this.state.endTimeValue.getDate();
        console.log(endDateFormatted);
        this.loadMultiDayAvailableEventTimes(
          startDateFormatted,
          endDateFormatted,
          this.props.demo.Content_ID
        );
        this.setState({ showAvailableEventTimes: true });
      }
    } else if (
      this.state.EvtDuration &&
      (this.state.endTimeValue || !this.state.IsMultiDaySelected)
    ) {
      var dateFormatted =
        value.getFullYear() +
        "-" +
        (value.getMonth() + 1) +
        "-" +
        value.getDate();
      this.loadAvailableEventTimes(
        dateFormatted,
        this.state.EvtDuration,
        this.props.demo.Content_ID
      );
      this.setState({ showAvailableEventTimes: true });
    }

    if (
      this.state.endTimeValue &&
      this._isStartTimeBeforeEndTime(value, this.state.endTimeValue)
    )
      this.setState({
        startDateValue: value,
        selectedStartTime: undefined,
      });
    //reset endtime if it's before starttime
    else
      this.setState({
        startDateValue: value,
        endTimeValue: undefined,
        selectedStartTime: undefined,
      });
  }

  _invalidStartDate(thisDate) {
    //if(Date.parse(thisDate) < Date.now() - 86400000)
    //console.log("prop.physicalContentRecord", this.props.demo);
    var leadTime = 0;
    if (
      this.props.demo &&
      this.props.demo.Content_LeadTime &&
      this.props.demo.Content_LeadTime > 0
      // this.state.UserInfo &&
      //this.state.UserInfo.UserActionsList &&
      //this.state.UserInfo.UserActionsList.Event &&
      //!this.state.UserInfo.UserActionsList.Event.Approve
    )
      leadTime = this.props.demo.Content_LeadTime * 86400000;
    // console.log("leadtime::: ", leadTime);
    // if (thisDate < Date.now() + leadTime - 86400000) return true;
    if (thisDate < Date.now()) return true;
    else return false;
  }
  _invalidEndDate(day) {
    //console.log('end day: ', day);
    if (
      Date.parse(day) < Date.parse(this.state.startDateValue) ||
      Date.parse(day) < Date.now() - 86400000
    )
      return true;
    else return false;
  }

  handleDurationChange(value) {
    var val = "";
    if (value === "Multidays") {
      this.setState({ IsMultiDaySelected: true, durationSelectedVal: value });
      val = "multidayevent";
    }
    if (value === "1.0 H") {
      this.setState({ EvtDuration: "0.1:00", durationSelectedVal: value });
      val = "0.1:00";
    }
    if (value === "1.5 H") {
      this.setState({ EvtDuration: "0.1:30", durationSelectedVal: value });
      val = "0.1:30";
    }
    if (value === "2.0 H") {
      this.setState({ EvtDuration: "0.2:00", durationSelectedVal: value });
      val = "0.2:00";
    }
    if (value === "2.5 H") {
      this.setState({ EvtDuration: "0.2:30", durationSelectedVal: value });
      val = "0.2:30";
    }
    if (value === "3.0 H") {
      this.setState({ EvtDuration: "0.3:00", durationSelectedVal: value });
      val = "0.3:00";
    }
    if (value === "3.5 H") {
      this.setState({ EvtDuration: "0.3:30", durationSelectedVal: value });
      val = "0.3:30";
    }
    if (value === "4.0 H") {
      this.setState({ EvtDuration: "0.4:00", durationSelectedVal: value });
      val = "0.4:00";
    }
    if (value === "4.5 H") {
      this.setState({ EvtDuration: "0.4:30", durationSelectedVal: value });
      val = "0.4:30";
    }
    if (value === "5.0 H") {
      this.setState({ EvtDuration: "0.5:00", durationSelectedVal: value });
      val = "0.5:00";
    }
    if (value === "5.5 H") {
      this.setState({ EvtDuration: "0.5:30", durationSelectedVal: value });
      val = "0.5:30";
    }
    if (value === "6.0 H") {
      this.setState({ EvtDuration: "0.6:00", durationSelectedVal: value });
      val = "0.6:00";
    }
    if (value === "6.5 H") {
      this.setState({ EvtDuration: "0.6:30", durationSelectedVal: value });
      val = "0.6:30";
    }
    if (value === "7.0 H") {
      this.setState({ EvtDuration: "0.7:00", durationSelectedVal: value });
      val = "0.7:00";
    }
    if (value === "7.5 H") {
      this.setState({ EvtDuration: "0.7:30", durationSelectedVal: value });
      val = "0.7:30";
    }
    if (value === "8.0 H") {
      this.setState({ EvtDuration: "0.8:00", durationSelectedVal: value });
      val = "0.8:00";
    }

    if (value === "Multidays") {
      if (this.state.startDateValue && this.state.endDateValue) {
        //if all data filled out...do this
        console.log(
          "diff in MS:",
          this.state.endDateValue - this.state.startDateValue
        );
        var startDateFormatted =
          this.state.startDateValue.getFullYear() +
          "-" +
          (this.state.startDateValue.getMonth() + 1) +
          "-" +
          this.state.startDateValue.getDate();
        console.log(startDateFormatted);
        var endDateFormatted =
          this.state.endDateValue.getFullYear() +
          "-" +
          (this.state.endDateValue.getMonth() + 1) +
          "-" +
          this.state.endDateValue.getDate();
        console.log(endDateFormatted);
        this.loadMultiDayAvailableEventTimes(
          startDateFormatted,
          endDateFormatted,
          this.props.demo.Content_ID
        );
        this.setState({ showAvailableEventTimes: true });
      } else {
        //ok to reset state...it's also set in the loadMultiDayAva...above.  Don't want to overwrite it.
        var EVObject = this.state.newEventRequestVM;
        EVObject.Event_Duration.Duration_ID = val;
        EVObject.Event_Duration.Duration_Name = "Multiday Event";

        this.setState({
          newEventRequestVM: EVObject,
          EvtDuration: val,
          Event_Duration: val,
        });
      }

      // this.setState({showEndTimeField: true}); //show end date if multidayevent selected
    } else {
      if (this.state.startDateValue) {
        var dateFormatted =
          this.state.startDateValue.getFullYear() +
          "-" +
          (this.state.startDateValue.getMonth() + 1) +
          "-" +
          this.state.startDateValue.getDate();
        //alert(dateFormatted);
        this.loadAvailableEventTimes(
          dateFormatted,
          val,
          this.props.demo.Content_ID
        );
        this.setState({ showAvailableEventTimes: true });
      }
      this.setState({ IsMultiDaySelected: false, endDateValue: undefined });

      var EVObject = this.state.newEventRequestVM;
      EVObject.Event_Duration.Duration_ID = val;

      this.setState({ newEventRequestVM: EVObject, duration_Value: val });
    }
  }

  _isStartTimeBeforeEndTime(startTime, endTime) {
    if (Date.parse(startTime) < Date.parse(endTime)) return true;
    else return false;
  }

  handleDemoEventDelLocChange(value) {
    console.log("**Del Location Select List Clicked with selection below");
    console.log(value);
    console.log("**All List of Del Locations below");
    console.log(this.state.eventDeliveryLocationData);

    var EVObject = this.state.newEventRequestVM;

    this.state.eventDeliveryLocationData.map((delLocaTyp) => {
      if (delLocaTyp.EventDeliveryLocation_Name == value) {
        EVObject.Event_DeliveryLocation = delLocaTyp; //JSON.parse(delLocaTyp);
        this.setState({
          EvtDelLocSelected: delLocaTyp,
          demoEvtDelLocVal: value,
          newEventRequestVM: EVObject,
        });
      }
    });
  }

  loadEventTypes() {
    var endpoint = "/metadata/GetEventTypes";
    let token = auth.getToken();

    callApiGetJson(endpoint, token).then((data) => {
      //console.log('EventType data:' + data.toString());
      if (data !== undefined)
        if (!this.state.isAdministrator) {
          // if (!this.state.UserActions.Equipment.Schedule) {
          data = data.filter((eventType) => {
            //var showThisRecord = false;
            if (eventType && eventType.EventType_ID !== 4)
              //4 = downtime
              return eventType;
          });
        }
      //}
      this.setState({
        eventTypeData: data,
        // isEvtListDisabled: false,
        isEvtTypeDisabled: false,
      });
    });
  }

  loadEventDeliveryLocations() {
    var endpoint = "/metadata/GetEventDeliveryLocations";
    let token = auth.getToken();

    callApiGetJson(endpoint, token).then((data) => {
      // console.log('EventDeliveryLocations data:' + data.toString());
      if (data !== undefined)
        this.setState({
          eventDeliveryLocationData: data,
          isDelLocDisabled: false,
        });
    });
  }

  render() {
    var spinnercontent = "";
    var EvtTypeList = undefined;
    var DelLocList = undefined;
    var TimezoneList = new Array();

    var MainPresenter = this.state.mainInstructor
      ? this.state.mainInstructor
      : null;

    console.log("Time Zone specific Time is ", this.state.timezoneSpecificTime);
    console.log("Main Presenter selected is ", this.state.mainInstructor);

    var opts = [
      "1.0 H",
      "1.5 H",
      "2.0 H",
      "2.5 H",
      "3.0 H",
      "3.5 H",
      "4.0 H",
      "4.5 H",
      "5.0 H",
      "6.0 H",
      "6.5 H",
      "7.0 H",
      "7.5 H",
      "8.0 H",
    ];
    var optsM = [
      "1.0 H",
      "1.5 H",
      "2.0 H",
      "2.5 H",
      "3.0 H",
      "3.5 H",
      "4.0 H",
      "4.5 H",
      "5.0 H",
      "6.0 H",
      "6.5 H",
      "7.0 H",
      "7.5 H",
      "8.0 H",
      "Multidays",
    ];

    var opt = this.props.demo.Is_MultidayCapable ? optsM : opts;
    var isCRTME = this.props.Is_TMECR ? true : false;

    if (this.state.TimeZoneData) {
      //var TimezList = new Array();
      this.state.TimeZoneData.map((tz) => {
        TimezoneList.push(tz.Timezone_Name);
      });
    }

    //var tzIsDisabled = this.state.timezoneValue ? true : false;

    var selectedStartTimeVal = this.state.selectedStartTime;

    var IsMultiday = this.state.IsMultiDaySelected;

    var isNeedToShowScheduleDemo = false;
    var FetchedSlots = undefined;

    if (
      this.state.showAvailableEventTimes &&
      this.state.eventAvailableEventTimes
    ) {
      isNeedToShowScheduleDemo = true;
      FetchedSlots = this.state.eventAvailableEventTimes;
    }

    if (this.state.eventTypeData) {
      EvtTypeList = new Array();
      this.state.eventTypeData.map((item) => {
        EvtTypeList.push(item.EventType_Name);
      });
    }

    if (this.state.eventDeliveryLocationData) {
      DelLocList = new Array();
      this.state.eventDeliveryLocationData.map((item) => {
        DelLocList.push(item.EventDeliveryLocation_Name);
      });
    }

    if (this.state.showAvailableSlotLoader) {
      spinnercontent = (
        <Layer position="center">
          <Box
            align="center"
            direction="row"
            gap="small"
            pad="small"
            key="small"
          >
            <Spinner size="small" />
            <Text size="small">Loading Available Time-Slots...</Text>
          </Box>
        </Layer>
      );
    }

    console.log("EventRequestObject is ", this.state.newEventRequestVM);
    //console.log("Start Date Selected is ", this.state.startDateValue);

    var isNextNotEnabled = true;
    if (
      this.state.newEventRequestVM.Event_DeliveryLocation &&
      this.state.newEventRequestVM.Event_DeliveryLocation
        .EventDeliveryLocation_ID &&
      this.state.newEventRequestVM.Event_Type &&
      this.state.newEventRequestVM.Event_Type.EventType_ID &&
      this.state.newEventRequestVM.Event_StartDate &&
      this.state.newEventRequestVM.Event_EndDate &&
      this.state.selectedStartTime
    ) {
      isNextNotEnabled = false;
    }

    var bLoadNextOverlay = this.state.showNextOverlayB;
    var evtVM = this.state.newEventRequestVM;
    var demo_d = this.state.DemoData;
    var timeZoneIANA = this.state.timezoneValue
      ? this.state.timezoneValue
      : null;

    var timeZoneNonwindows =
      this.state.timezoneValue && this.props.Is_TMECR
        ? findIana(this.state.timezoneValue)[0]
        : moment.tz.guess();

    return (
      <Layer animate modal position="center" onEsc={this.props.hide}>
        <Box align="center" justify="center">
          <Box align="center" justify="center" border={{ style: "solid" }}>
            <Box
              align="center"
              justify="center"
              background={{ color: "brand" }}
              fill="horizontal"
            >
              <Box
                align="center"
                justify="between"
                direction="row"
                gap="medium"
                fill="horizontal"
              >
                <Heading size="small" level="1" margin="small">
                  Schedule a demonstration
                </Heading>
                <Button icon={<Close />} secondary onClick={this.props.hide} />
              </Box>
              <Text size="xlarge">{this.props.Content_Title}</Text>
            </Box>
            <Box
              align="stretch"
              justify="start"
              direction="column"
              pad="medium"
              gap="medium"
              fill="horizontal"
            >
              <Box
                align="stretch"
                justify="start"
                direction="column"
                pad="medium"
                gap="medium"
                fill="horizontal"
              >
                <Grid>
                  <Text>Demo Type</Text>
                  <SingleSelect
                    value={this.state.demoEvtTypeVal}
                    placeholder="Select Demo-Event Type"
                    options={EvtTypeList}
                    disabled={this.state.isEvtTypeDisabled}
                    onChange={this.handleDemoEventTypeChange}
                  />
                </Grid>
                {isCRTME && (
                  <Grid>
                    <Clock />
                    <SingleSelect
                      value={this.state.timezoneValue}
                      placeholder="Select Event Timezone"
                      options={TimezoneList}
                      onChange={this.handleTimeZone}
                      //disabled={tzIsDisabled}
                      //icon={<Clock />}
                    />
                  </Grid>
                )}
                <Grid>
                  <Text>Duration</Text>
                  <SingleSelect
                    options={opt}
                    value={this.state.durationSelectedVal}
                    placeholder="Select Duration of Event"
                    onChange={this.handleDurationChange}
                  />
                </Grid>
                <Grid>
                  <Text>Where</Text>
                  <SingleSelect
                    value={this.state.demoEvtDelLocVal}
                    placeholder="Select Demo-Delivery Location"
                    options={DelLocList}
                    disabled={this.state.isDelLocDisabled}
                    onChange={this.handleDemoEventDelLocChange}
                  />
                </Grid>
                {spinnercontent}
                <Grid>
                  <Text>Date / Start Time</Text>
                  <DateInput
                    inline={false}
                    format="mm/dd/yyyy"
                    value={undefined} //{this.state.startDateValue}
                    onChange={this._handleStartDateChange}
                  />
                  {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                      //shouldDisableDate={this._invalidStartDate}
                      floatingLabelText="Date/Start Time"
                      firstDayOfWeek={0}
                      hintText="Start Date"
                      fullWidth
                      //label="Start Date"
                      format="MM/dd/yyyy"
                      // margin="normal"
                      //id="date-picker-dialog"
                      //label="Start Date"
                      value={this.state.startDateValue}
                      onChange={(date) => this._handleStartDateChange(date)}
                      autoOk={true}
                      // KeyboardButtonProps={{
                      //   "aria-label": "change date",
                      // }}
                    />
                  </MuiPickersUtilsProvider> */}
                  {/* <Text>Date / Start Time</Text>
                <DateInput format="mm/dd/yyyy" /> */}
                </Grid>
                {this.state.startDateValue &&
                  isNextNotEnabled &&
                  this.state.selectedStartActualDateVal === undefined && (
                    <Text size="xxxsmall" weight="bold" color="brand">
                      {new Date(this.state.startDateValue).toDateString()}
                      {/* {new Date(this.state.startDateValue).getMonth() +
                        1 +
                        "-" +
                        new Date(this.state.startDateValue).getDate() +
                        "-" +
                        new Date(this.state.startDateValue).getFullYear()} */}
                    </Text>
                  )}
                {this.state.selectedStartTime &&
                  !isNextNotEnabled &&
                  this.state.selectedStartActualDateVal &&
                  this.props.Is_TMECR &&
                  this.state.timezoneSpecificTime && (
                    <Text size="xxxsmall" weight="bold" color="brand">
                      {new Date(
                        this.state.selectedStartActualDateVal
                      ).toDateString() +
                        " " +
                        this.state.timezoneSpecificTime +
                        " (" +
                        timeZoneNonwindows +
                        "" +
                        " TZ)"}
                    </Text>
                  )}
                {this.state.selectedStartTime &&
                  !isNextNotEnabled &&
                  this.state.selectedStartActualDateVal &&
                  !this.props.Is_TMECR && (
                    <Text size="xxxsmall" weight="bold" color="brand">
                      {new Date(
                        this.state.selectedStartActualDateVal
                      ).getMonth() +
                        1 +
                        "-" +
                        new Date(
                          this.state.selectedStartActualDateVal
                        ).getDate() +
                        "-" +
                        new Date(
                          this.state.selectedStartActualDateVal
                        ).getFullYear() +
                        " " +
                        this.state.selectedStartTime}
                    </Text>
                  )}
                {isNeedToShowScheduleDemo && FetchedSlots && (
                  <AvailableTimeSlots
                    demo={this.props.demo}
                    tzIANA={timeZoneIANA}
                    Availabilities={FetchedSlots}
                    HandleSelectedTime={this._handleAvailableTimeSelected}
                    hide={this._hideAvailableTimeWindow}
                  />
                )}
                {bLoadNextOverlay && (
                  <ScheduleDemoOverlayB
                    evtReqVM={evtVM}
                    demo={demo_d}
                    is_TMECR={isCRTME}
                    timeZoneCR={timeZoneIANA}
                    mainPresenter={MainPresenter}
                    hide={this._hideNextOverlayB}
                    hideback={this._hideOnlyOverlayB}
                    calledBy={this.props.calledBy}
                  />
                )}
                {IsMultiday && (
                  <Grid>
                    {/*                     <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        shouldDisableDate={this._invalidStartDate}
                        firstDayOfWeek={0}
                        hintText="Start Date"
                        fullWidth
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="date-picker-dialog"
                        label="End Date"
                        value={this.state.endDateValue}
                        onChange={this._handleEndDateChange}
                        autoOk={true}
                        // KeyboardButtonProps={{
                        //   "aria-label": "change date",
                        // }}
                      />
                    </MuiPickersUtilsProvider> */}
                    <Text>Date / End Time</Text>
                    <DateInput
                      inline={false}
                      format="mm/dd/yyyy"
                      value={this.state.endDateValue}
                      onChange={this._handleEndDateChange}
                    />
                  </Grid>
                )}
                {isCRTME && (
                  <Grid>
                    <Text>Main Presenter Email</Text>
                    <TextInput
                      value={this.state.mainInstructor}
                      onChange={(event) =>
                        this.handleMainInstructor(event.target.value)
                      }
                    />
                  </Grid>
                )}
              </Box>
            </Box>
            <Box
              align="center"
              justify="center"
              direction="row"
              gap="large"
              margin="medium"
            >
              <Button
                label="Next"
                active={false}
                primary
                reverse
                disabled={isNextNotEnabled}
                onClick={this._showNextOverlayB}
              />
            </Box>
          </Box>
        </Box>
      </Layer>
    );
  }
}

export default ScheduleDemoOverlayA;
